import React from 'react'

import dbCodes from '../../server/dbCodes.js'
import {getColliTypeName} from '../../utils/getColliTypeName.js'
import {Button, Colors, Card, H4, S1, P, Modal, Icon} from '../../src/components/UI/index.js'
import Select from './UI/Select.js'
import {formSpacing} from '../../src/components/UI/forms/index.js'

class DeliverPopup extends React.Component {
    constructor(props) {
        super(props)

        this.initialState = {
            isOpen: false,
            colli: [],
            reseller: null
        }

        this.state = structuredClone(this.initialState)
    }

    open(colli, reseller) {
        colli = structuredClone(colli)

        colli.map((collo) => {
            if (collo.status !== 'delivered') {
                collo.status = 'missing'
            }
        })

        this.setState({isOpen: true, colli, reseller})

        return new Promise((resolve, reject) => {
            this.resolve = resolve
            this.reject = reject
        })
    }

    close() {
        this.setState(this.initialState)
    }

    updateColloStatus(colloIndex, event) {
        const colli = [...this.state.colli]

        colli[colloIndex].status = event.target.value

        this.setState({colli})
    }

    submit() {
        const {colli} = this.state

        this.resolve(colli)
    }

    render() {
        const {isOpen, colli, reseller} = this.state

        return (
            <Modal show={isOpen} style={{width: 600, maxWidth: '90%'}} onClose={this.close.bind(this)}>
                <div style={{display: 'flex', marginBottom: 24}}>
                    <Icon style={{marginRight: 6, color: Colors.errorBright, fontSize: 22}} icon='mdi mdi-alert' />
                    <H4>Bezorging incompleet</H4>

                </div>

                <P style={{marginBottom: 12}}>Onderstaande colli zijn niet bezorgd. Geef hieronder een reden op, of druk op Terug om ze alsnog te bezorgen.</P>

                {colli.map((collo, colloIndex) => {
                    if (collo.status !== 'delivered') {
                        return (
                            <Card key={`collo${collo.index}`} style={{background: Colors.grey20, padding: formSpacing.inset, marginBottom: 12}}>
                                <div style={{display: 'flex', alignItems: 'center', marginBottom: 12}}>
                                    <S1 style={{marginRight: 12}}>{collo.index + 1}</S1>

                                    <P style={{flex: 1, marginRight: 6}}>{`${collo.barcode || 'Geen barcode'}`}</P>
                                    <P style={{flex: 1, marginLeft: 6}}>{getColliTypeName(collo.type, reseller)}</P>
                                </div>

                                <Select
                                    closeButton
                                    label='Reden'
                                    value={collo.status}
                                    options={[
                                        {value: 'missing', title: dbCodes.colloStatus['missing']},
                                        {value: 'refused', title: dbCodes.colloStatus['refused']}
                                    ]}
                                    onChange={this.updateColloStatus.bind(this, colloIndex)}
                                />
                            </Card>
                        )
                    }
                })}

                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', columnGap: formSpacing.columnGap, marginTop: 24}}>
                    <Button
                        variant='text'
                        onClick={this.close.bind(this)}
                        label='Terug'
                    />

                    <Button
                        variant='text'
                        onClick={this.submit.bind(this)}
                        label='Bevestigen'
                    />

                </div>
            </Modal>
        )
    }
}

export default DeliverPopup
